import type { ChatMessage } from "../types";
import { AIChatAssistantFrame } from "./AIChatAssistantFrame";

type Props = {
  message: ChatMessage;
};

export function AIChatTextMessage({ message }: Props) {
  return (
    <AIChatAssistantFrame message={message}>
      <p className="text-sm leading-6 text-[#374151]">{message.text}</p>
    </AIChatAssistantFrame>
  );
}
